export interface NewsItem {
  id: string;
  title: string;
  category: '作品资讯' | '明星动态';
  date: string;
  summary: string;
  content: string;
  relatedMovie?: string;
  relatedStar?: string;
}

export const news: NewsItem[] = [
  {
    id: 'n01',
    title: '《光的轨迹》口碑持续走高，科幻外壳下的人性叙事引发热议',
    category: '作品资讯',
    date: '2024-08-02',
    summary:
      '河北彩花主演的科幻剧情片《光的轨迹》上映后讨论度持续攀升，影片以“人造光源”为设定，探讨个体与城市之间的依存关系。',
    content:
      '《光的轨迹》自上映以来，凭借独特的设定与克制的叙事获得大量讨论。影片构建了一座依赖人造光源运转的城市，河北彩花饰演的光轨工程师在维护系统的过程中，逐渐发现被隐藏的运行真相。\n\n不少观众表示，影片最动人的部分并非科幻奇观，而是人物在极端环境下的选择。导演佐藤一树在采访中提到，团队希望通过“光”的意象，讨论人与城市、个体与集体之间的微妙关系。\n\n截至目前，影片仍在热映中，相关话题持续发酵。',
    relatedMovie: 'm06',
    relatedStar: 's01',
  },
  {
    id: 'n02',
    title: '河北彩花回应新作挑战：希望尝试更复杂的角色层次',
    category: '明星动态',
    date: '2024-07-25',
    summary:
      '谈及新片《光的轨迹》，河北彩花表示这次的角色让她重新思考表演的边界，未来希望挑战更复杂的角色层次。',
    content:
      '在近期的一次采访中，河北彩花分享了拍摄《光的轨迹》的感受。她提到，为塑造工程师这一角色，自己提前学习了大量与光学、工程相关的知识，并在拍摄现场反复与导演沟通人物的动机。\n\n“我希望观众看到的不是标签，而是一个真实的人。”她说。谈及未来规划，她表示希望继续尝试不同类型的作品，尤其是人物层次更复杂的角色。',
    relatedMovie: 'm06',
    relatedStar: 's01',
  },
  {
    id: 'n03',
    title: '《午夜列车》定档11月，悬疑氛围拉满',
    category: '作品资讯',
    date: '2024-10-18',
    summary:
      '电影《午夜列车》正式宣布定档11月22日，河北彩花与高桥南、藤井翔共同主演，预告片释出后引发关注。',
    content:
      '《午夜列车》讲述了一班末班列车驶出站台后，车厢里的乘客发现彼此都指向同一桩旧事的故事。影片由佐藤一树执导，河北彩花、高桥南、藤井翔主演。\n\n首支预告片中，密闭的车厢、湿冷的车窗与紧张的氛围成为讨论焦点。片方表示，影片将在悬念之外，加入对人性与选择的探讨。影片定档11月22日。',
    relatedMovie: 'm10',
    relatedStar: 's01',
  },
  {
    id: 'n04',
    title: '《樱花之约》收官，口碑与热度双线飘红',
    category: '作品资讯',
    date: '2024-06-20',
    summary:
      '电视剧《樱花之约》迎来大结局，河北彩花与木村光的表演收获大量好评，剧集相关话题登上热搜。',
    content:
      '《樱花之约》以樱花季节的约定为主线，讲述一对好友多年后重逢的故事。全剧共12集，自播出以来保持稳定讨论度。\n\n大结局播出后，不少观众表示被剧中克制的情绪处理打动。河北彩花在剧中饰演的角色，被认为完成了从青涩到成熟的完整弧线。',
    relatedMovie: 'm03',
    relatedStar: 's01',
  },
  {
    id: 'n05',
    title: '《东京往事》获年度剧集提名，年代叙事再受关注',
    category: '作品资讯',
    date: '2024-01-09',
    summary:
      '年代剧《东京往事》获得年度剧集提名，河北彩花与高桥南、中村雅、白石怜的群像表演成为亮点。',
    content:
      '《东京往事》横跨数十年，讲述一个普通家庭三个孩子的人生轨迹。全剧共16集，以细腻的年代质感与扎实的群像刻画收获好评。\n\n此次获得年度剧集提名，也让年代题材再次受到市场关注。制片方透露，团队为还原年代细节做了大量前期调研。',
    relatedMovie: 'm05',
    relatedStar: 's01',
  },
  {
    id: 'n06',
    title: '白石怜谈表演：舞台经验让我更懂“现场”',
    category: '明星动态',
    date: '2023-12-15',
    summary: '从舞台剧到影视剧，白石怜分享了自己对表演的理解，称舞台经验让自己的镜头表演更加专注。',
    content:
      '白石怜以舞台剧出道，近年来在影视领域同样表现亮眼。谈到两种表演形式的差异，她表示舞台让她学会了如何在现场与观众“共呼吸”。\n\n“镜头前更安静，但内心的节奏是一样的。”她说。未来，她希望继续在两种媒介之间穿梭，寻找更多可能性。',
    relatedStar: 's02',
  },
  {
    id: 'n07',
    title: '河北彩花出席新片首映礼，简约气质造型获好评',
    category: '明星动态',
    date: '2024-07-19',
    summary: '《光的轨迹》首映礼举行，河北彩花以简约优雅的造型亮相红毯，与主创团队一同分享拍摄幕后。',
    content:
      '《光的轨迹》首映礼当晚，河北彩花与导演佐藤一树及主创团队一同出席。她以简约的深色造型亮相，被现场媒体评价为“克制而有力量”。\n\n首映结束后，主创团队与观众进行了映后交流，分享了影片从设定到落地的过程。',
    relatedMovie: 'm06',
    relatedStar: 's01',
  },
  {
    id: 'n08',
    title: '《海街物语》发布全新剧照，临海小镇氛围感出圈',
    category: '作品资讯',
    date: '2023-09-01',
    summary: '电影《海街物语》发布一组全新剧照，临海小镇与老码头的画面引发网友讨论，氛围感十足。',
    content:
      '《海街物语》以一座临海小镇为背景，讲述老码头与几代人命运之间的牵绊。此次发布的剧照以黄昏光线为主，呈现出温暖又略带感伤的气质。\n\n导演宫本隼人表示，团队希望用画面传递时间的重量，“让观众相信这里真的有人生活过”。',
    relatedMovie: 'm09',
    relatedStar: 's01',
  },
  {
    id: 'n09',
    title: '木村光加盟新项目，尝试全新题材',
    category: '明星动态',
    date: '2024-09-05',
    summary: '新生代演员木村光确认加盟全新项目，将挑战此前未尝试过的题材，具体信息暂未完全公开。',
    content:
      '木村光近年来凭借青春题材作品进入大众视野，此次她将挑战全新题材。剧组透露，项目已完成前期筹备，将于年内开机。\n\n“我想让大家看到不一样的我。”木村光在社交平台上写道。',
    relatedStar: 's05',
  },
  {
    id: 'n10',
    title: '《星尘之下》重映，观众重温星空下的约定',
    category: '作品资讯',
    date: '2023-10-14',
    summary: '爱情奇幻电影《星尘之下》迎来重映，不少观众借此机会重温片中星空下的约定。',
    content:
      '《星尘之下》讲述两个相信星象的人在一座观测站相识的故事，影片以浪漫的星空意象与克制的情绪著称。\n\n此次重映吸引了不少当年看过影片的观众回到影院。有观众表示，多年后再看，对“约定”二字有了不同理解。',
    relatedMovie: 'm12',
    relatedStar: 's01',
  },
];